import {action, observable, makeObservable} from 'mobx';
import {ReportGeneratorStore} from './ReportGeneratorStore';
import {endProc} from '../../../_shared/GWTBridge/invoke/procMain';

export class ReportGeneratorsStore {
    reportGeneratorsStore: Map<string, ReportGeneratorStore> = new Map<
        string,
        ReportGeneratorStore
    >([]);
    @observable currentScreen: ReportGeneratorStore;

    constructor() {
        makeObservable(this);
    }

    @action
    setCurrentScreen = (currentScreen: ReportGeneratorStore | null) => {
        this.currentScreen = currentScreen;
    };

    @action
    open = (session: string) => {
        if (session) {
            let reportGenerator = this.reportGeneratorsStore.get(session);
            if (!reportGenerator) {
                reportGenerator = new ReportGeneratorStore(session);
                this.reportGeneratorsStore.set(session, reportGenerator);
            }
            this.setCurrentScreen(reportGenerator);
            reportGenerator.open();
        }
    };

    @action
    close = (session: string) => {
        this.hide(session);
        this.reportGeneratorsStore.delete(session);
        endProc();
    };

    @action
    hide = (session: string) => {
        const rg = this.reportGeneratorsStore.get(session);
        if (rg) {
            rg.close();
            this.currentScreen?.session === session && this.setCurrentScreen(null);
        }
    };
}

export const reportGeneratorsStore = new ReportGeneratorsStore();
